import { useEffect, useState } from "react";
import { useLocation } from "react-router";

interface PageTransitionProps {
	children: React.ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
	const location = useLocation();
	const [displayLocation, setDisplayLocation] = useState(location);
	const [transitionStage, setTransitionStage] = useState("fadeIn");

	useEffect(() => {
		if (location !== displayLocation) {
			setTransitionStage("fadeOut");
		}
	}, [location, displayLocation]);

	return (
		<div
			className={`page-transition ${transitionStage}`}
			onAnimationEnd={() => {
				if (transitionStage === "fadeOut") {
					setTransitionStage("fadeIn");
					setDisplayLocation(location);
				}
			}}
		>
			{displayLocation.pathname === location.pathname ? children : null}
		</div>
	);
}
